import apiClient from "@/api/client";

export interface MonitoringDashboard {
  id: number;
  tenant_id: number;
  label: string;
  grafana_uid: string | null;
  grafana_url: string | null;
  last_synced_at: string | null;
  last_error: string | null;
  created_at: string;
  updated_at: string;
}

export interface DashboardCreate {
  tenant_id: number;
  label?: string | null;
}

export async function listMonitoringDashboards(): Promise<MonitoringDashboard[]> {
  const { data } = await apiClient.get<MonitoringDashboard[]>(
    "/admin/monitoring/dashboards",
  );
  return data;
}

export async function createMonitoringDashboard(
  payload: DashboardCreate,
): Promise<MonitoringDashboard> {
  const { data } = await apiClient.post<MonitoringDashboard>(
    "/admin/monitoring/dashboards", payload,
  );
  return data;
}

export async function syncMonitoringDashboard(
  tenantId: number,
): Promise<MonitoringDashboard> {
  const { data } = await apiClient.post<MonitoringDashboard>(
    `/admin/monitoring/dashboards/${tenantId}/sync`,
  );
  return data;
}

export async function deleteMonitoringDashboard(
  tenantId: number,
): Promise<void> {
  await apiClient.delete(`/admin/monitoring/dashboards/${tenantId}`);
}
